import zsmLayout from '@/zsm-layout/index'

const courseCRouter = {
  path: '/exam',
  component: zsmLayout,
  name: 'market',
  redirect: '/exam/index',
  children: [
    {
      path: '/exam',
      component: () => import('@/view/exam/index'),
      hidden: true,
      redirect: '/exam/index',
      name: 'exam',
      children: [
        {
          path: '/exam/question',
          component: () => import('@/view/exam/question'),
          name: 'examQuestion'
        },
        {
          path: '/exam/batch',
          component: () => import('@/view/exam/batch'),
          name: 'examBatch'
        },
        {
          path: '/exam/index',
          component: () => import('@/view/exam/exam'),
          name: 'examIndex'
        },
        {
          path: '/exam/add',
          component: () => import('@/view/exam/add-exam'),
          name: 'examIndex'
        },
        {
          path: '/exam/add-question',
          component: () => import('@/view/exam/add-question'),
          name: 'examQuestion'
        }
      ]
    }
  ]
}

export default courseCRouter
